import { render, staticRenderFns } from "./GridPost.vue?vue&type=template&id=034cfdee&"
import script from "./GridPost.vue?vue&type=script&lang=js&"
export * from "./GridPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports